/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
/** @docs-private */
export function getSbbTextexpandInvalidError(): Error {
  return Error('Collapsed and expanded must be defined!');
}
